import { useCallback, useState } from 'react';

interface UseDisclosureReturnT {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onToggle: () => void;
}

export const useDisclosure = (defaultIsOpen = false): UseDisclosureReturnT => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultIsOpen);
  const onOpen = useCallback(() => setIsOpen(true), []);
  const onClose = useCallback(() => setIsOpen(false), []);
  const onToggle = useCallback(
    () => setIsOpen((previousIsopen) => !previousIsopen),
    []
  );

  return { isOpen, onOpen, onClose, onToggle };
};
